<!-- @format -->
<template>
	<div class="success">
		<img class="success-icon" src="../../assets/img/icon-check.png" />
		<div class="success-t1">提交成功</div>
		<div class="success-t2">电子发票将在7个工作日为您开具</div>
		<van-button block type="primary" plain @click="goBack">返回订单详情</van-button>
	</div>
</template>

<script>

	export default {
	    name:'InvoicingSuccess',
	    data () {
	        return {

	        }
	    },

	    computed: {

	    },

	    created() {

	    },

	    methods: {
			goBack(){
				this.$router.push(`/order/detail/${this.$route.params.id}`)
			}
	    }
	}
</script>

<style lang="less" scoped>
	.success{
		width:100vw;
		height: 100vh;
		background-color: #fff;
		padding:160px 50px 0;
		box-sizing: border-box;
		text-align: center;
		&-icon{
			width: 160px;
			height: 160px;
		}
		&-t1{
			font-size: 36px;
			color: #1F2329;
			margin:20px 0;
		}
		&-t2{
			font-size: 30px;
			color: #8F959E;
			margin-bottom: 50px;
		}
	}
</style>
